<template>
  <div>
    <validation-observer ref="awaitRules">
      <b-form>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('DEBTIA_TYPE')"
              label-for="await-type"
            >
              <v-select
                v-model="awaitType"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="awaitTypeOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="awaitType"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="awaitType === 1"
            sm="12"
          >
            <validation-provider
              #default="{ errors }"
              name="Days"
              rules="required|integer"
            >
              <b-form-group
                :label="$t('DEBTIA_DAYS')"
                label-for="days"
              >
                <b-form-input
                  v-model="days"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Days"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
              <b-row>
                <b-col
                  md="12"
                >
                  <b-form-group>
                    <b-form-checkbox
                      v-model="awaitCheckbox"
                      class="custom-control-primary"
                      name="checkbox-await"
                    >
                      {{ $t('DEBTIA_AWAIT_CHECKBOX') }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </validation-provider>
            <b-form-group>
              <b-form-checkbox
                v-model="skipAwait"
                class="custom-control-primary"
                name="skip-await"
              >
                {{ $t('DEBTIA_SKIP_WEEKEND') }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col
            v-if="awaitType === 1"
            cols="12"
          >
            <b-button
              variant="primary"
              type="submit"
              class="addAwaitBtn"
              @click.prevent="validationAwaitForm"
            >
              {{ $t('DEBTIA_SUBMIT') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup,
  BFormInput,
  BButton,
  BForm,
  BRow,
  BCol,
  BFormCheckbox,
  // BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import { required, integer } from '@validations'

export default {
  components: {
    // BCardCode,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    // BInputGroup,
    BFormInput,
    BButton,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      integer,
      awaitType: 0,
      awaitCheckbox: false,
      days: '',
      awaitTypeOptions: [
        { label: 'Time Based', value: 1 },
        { label: 'Action Based', value: 2 },
      ],
      skipAwait: false,
    }
  },
  created() {
  },
  methods: {
    validationAwaitForm() {
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 1,
        module_order: 1,
        number_of_days: Number(this.days),
        type: this.awaitType,
        skip_interest_calculation: this.awaitCheckbox,
        skip_monday: this.skipAwait,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      this.$refs.awaitRules.validate().then(success => {
        if (success) {
          const url = '/process/module/add'
          axios.post(url, dataObj).then(response => {
            if (response.status === 200) {
              this.awaitType = 0
              this.awaitCheckbox = false
              this.days = ''
              const returnObj = {
                parentID: this.conditionObject.parentID,
                depend: dataObj.depends_on,
              }
              returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
              this.$emit('closeAwaitModal', returnObj)
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .addAwaitBtn {
    width: 100%;
  }
</style>
